import request from '@/utils/request.js'
import { V3 } from '@/utils/config.js'


export function getOptions() {
    return request({
        url: '/'+ V3 +'/common',
        method: 'get',
    })
}

export function getDevices() {
    return request({
        url: '/'+ V3 +'/common/devices',
        method: 'get',
    })
}

export function getExternalDevices() {
    return request({
        url: '/'+ V3 +'/common/external-devices',
        method: 'get',
    })
}


export function getRegions() {
    return request({
        url: '/'+ V3 +'/common/regions',
        method: 'get',
    })
}

export function getCardTypes() {
    return request({
        url: '/'+ V3 +'/common/card-types',
        method: 'get',
    })
}

export function getStopTypes() {
    return request({
        url: '/'+ V3 +'/common/stop-types',
        method: 'get',
    })
}

export function getRouteDayparts() {
    return request({
        url: '/'+ V3 +'/common/route-dayparts',
        method: 'get',
    })
}

export function getRouteOptions() {
    return request({
        url: '/'+ V3 +'/common/route-options',
        method: 'get',
    })
}

export function getRouteTypes() {
    return request({
        url: '/'+ V3 +'/common/route-Types',
        method: 'get',
    })
}

export function getBuses(params={}) {
    return request({
        url: '/'+ V3 +'/common/buses',
        method: 'get',
        params
    })
}

export function getDrivers(params={}) {
    return request({
        url: '/'+ V3 +'/common/drivers',
        method: 'get',
        params
    })
}

export function getAids() {
    return request({
        url: '/'+ V3 +'/common/aids',
        method: 'get',
    })
}


export function getNotifierTypes() {
    return request({
        url: '/'+ V3 +'/common/notifier-types',
        method: 'get',
    })
}

export function getRoutes() {
    return request({
        url: '/'+ V3 +'/common/routes',
        method: 'get',
    })
}

export function getMessageReceivers() {
    return request({
        url: '/'+ V3 +'/common/message-receivers',
        method: 'get',
    })
}

export function getMessageTypes() {
    return request({
        url: '/'+ V3 +'/common/message-types',
        method: 'get',
    })
}

export function getDefectTypes() {
    return request({
        url: '/'+ V3 +'/common/inspection-defect-types',
        method: 'get',
    })
}

export function getStudents() {
    return request({
        url: '/'+ V3 +'/common/students',
        method: 'get',
    })
}

export function getPoints(params) {
    return request({
        url: '/'+ V3 +'/points',
        method: 'get',
        params,
    })
}